module.exports = __webpack_public_path__ + "img/contains-allergen.dfd0200a.png";